import { render } from "./BatchParticipants.vue?vue&type=template&id=73626e6e&scoped=true"
import script from "./BatchParticipants.vue?vue&type=script&lang=js"
export * from "./BatchParticipants.vue?vue&type=script&lang=js"

import "./BatchParticipants.vue?vue&type=style&index=0&id=73626e6e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73626e6e"]])

export default __exports__